import { activeFestivalBusRoutesQuery, bussesQuery } from '@/api/queries';
import { Bus } from '@packages/types';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

type BusWithOptionalLabel = Bus & { label?: string; saleState?: 'active' | 'hidden' | 'soldOut' };
export type DisplayBus = BusWithOptionalLabel & {
  label: string;
  dateLabel: string;
  timeLabel: string;
};

export const useBus = (festivalEditionId?: string) => {
  const legacyQuery = useQuery({ ...bussesQuery(), enabled: !festivalEditionId });
  const activeQuery = useQuery(activeFestivalBusRoutesQuery(festivalEditionId));
  const bussesRaw = (festivalEditionId ? activeQuery.data : legacyQuery.data) as
    | BusWithOptionalLabel[]
    | undefined;
  const isLoading = festivalEditionId ? activeQuery.isLoading : legacyQuery.isLoading;

  const busses = useMemo<DisplayBus[]>(() => {
    return (bussesRaw ?? []).map((bus) => {
      const departureDate = new Date(bus.departureTime);

      const departureTimeLabel = new Intl.DateTimeFormat('de-DE', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Berlin',
      }).format(departureDate);

      const weekdayLabel = new Intl.DateTimeFormat('de-DE', {
        weekday: 'long',
        timeZone: 'Europe/Berlin',
      }).format(departureDate);

      return {
        ...bus,
        label: bus.label ?? `${weekdayLabel}, ${departureTimeLabel}`,
        dateLabel: weekdayLabel,
        timeLabel: departureTimeLabel,
      };
    });
  }, [bussesRaw]);

  return { busses, isLoading };
};
